import settings from './settings.json';

export const { TRANSPARENT } = settings;
export const { HIDDEN_BORDER } = settings;
export const { PROXIMA_NOVA } = settings;
export const { INPUT_FONT_SIZE } = settings;
export const { INPUT_LINE_HEIGHT } = settings;
